
import { useState } from 'react';

import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';

import Button from 'src/onboarding/components/ui/button/Button';

import { Title } from 'src/onboarding/components/typography/Title/Title';
import { MultiCheck } from 'src/onboarding/components/ui/multi-check/MultiCheck';
import { MultiOption } from 'src/onboarding/components/ui/multi-check/Option';

import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const weightlossChallenges = useStore((state) => state.weightlossChallenges);
  const setWeightlossChallenges = useStore((state) => state.setWeightlossChallenges);
  const [next, setNext] = useState(weightlossChallenges.length > 0);
  const { onNext, onPrev, currentIndex } = useNav();

  const handleChange = (value) => {
    setWeightlossChallenges(value);
    setNext(value.length > 0);
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.weightlossChallenges.title')}</Title>
      </div>

      <div className={'controls'} style={{ marginBottom: 70 }}>
        <MultiCheck defaultValue={weightlossChallenges} onChange={handleChange}>
          <MultiOption value={'Strong cravings for food'}>
            <span>🍩</span> {t('onboarding.weightlossChallenges.options.strongCravings')}
          </MultiOption>
          <MultiOption value={'Staying motivated'}>
            <span>💭</span> {t('onboarding.weightlossChallenges.options.stayingMotivated')}
          </MultiOption>
          <MultiOption value={'Controlling portion sizes'}>
            <span>🍽️</span> {t('onboarding.weightlossChallenges.options.portionSizes')}
          </MultiOption>
          <MultiOption value={"Knowing what to eat"}>
            <span>🤔</span> {t('onboarding.weightlossChallenges.options.whatEat')}
          </MultiOption>
          <MultiOption value={'Not enough free time'}>
            <span>⏰</span> {t('onboarding.weightlossChallenges.options.freeTime')}
          </MultiOption>
           <MultiOption value={'Other'}>
            <span>✨</span> {t('onboarding.weightlossChallenges.options.other')}
          </MultiOption>
        </MultiCheck>
        <div className={'overlay'}></div>
      </div>

      <div className={'next-wrapper'}>
        <Button
          className={next ? '' : 'disabled'}
          title={t('onboarding.weightlossChallenges.continue')}
          onClick={() => {
            if (!next) return;
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'weightloss-challenges',
              answer: weightlossChallenges.join(', '),
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}

export default Page;
